import { ComponentPropsWithoutRef } from 'react';

export default function LiquidityProviderIcon(
  props: ComponentPropsWithoutRef<'svg'>,
) {
  return (
    <svg
      version="1.1"
      viewBox="0 0 13 13"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <circle cx="6.5" cy="6.5" r="6" stroke="currentColor" />
        <path
          d="m4.3922 9.4473v-3.3904c0-0.07822-0.0027-0.16385-0.00809-0.25691-0.00539-0.09305-0.01214-0.18813-0.02023-0.28523l1.5657 3.0384c0.04855 0.0944 0.11396 0.16588 0.19622 0.21443 0.08227 0.04855 0.17599 0.07282 0.28118 0.07282h0.18611c0.10519 0 0.19892-0.02427 0.28118-0.07282s0.14767-0.12002 0.19622-0.21443l1.5657-3.0303c-0.01079 0.0944-0.0182 0.18745-0.02225 0.27916-0.00405 0.0917-0.00607 0.17667-0.00607 0.25488v3.3904h1.2056v-5.8947h-1.0438c-0.05934 0-0.11126 0.00135-0.15576 0.00405-0.04451 0.0027-0.08429 0.01079-0.11935 0.02427-0.03506 0.01349-0.06676 0.03439-0.09508 0.06271s-0.05596 0.06811-0.08294 0.11935l-1.5131 2.9777c-0.05664 0.10249-0.10991 0.21038-0.15981 0.32366s-0.09777 0.22926-0.14362 0.34794c-0.04585-0.11598-0.09372-0.22926-0.14362-0.33984-0.04989-0.11058-0.10182-0.21712-0.15576-0.31962l-1.5172-2.9898c-0.02697-0.05124-0.05461-0.09103-0.08293-0.11935s-0.06002-0.04922-0.09508-0.0627c-0.03506-0.01349-0.07485-0.02158-0.11935-0.02428s-0.09642-0.00405-0.15576-0.00405h-1.0438v5.8947z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}
